import { ApiService as api } from "../Services/APIService";
import { TemplateService } from "../Services/TemplateService";
import { UtilService as util } from "../Services/UtilService";
import { LangService } from "../Services/LangService";

// ComponentName
const componentName = 'sermon';

const seriesScrollerTemplate = "SeriesScroller";
const seriesDetailTemplate = "SeriesDetail";
const sermonDetailTemplate = "SermonDetail";
const sermonNotesTemplate = "SermonDetailNotes";

const sermonLatestTemplate = "SermonLatest";
const sermonLatestCardTemplate = "SermonLatestCard";
const sermonLatestCardWideTemplate = "SermonLatestCardWide";

const recentSermonScrollerTemplate = "RecentSermonScroller";
const recentSermonsToLoad = 15;

export class SermonModule {


    static SetupSermonInit() {

        DEBUG && console.info('Sermon Detail *--> Init');

        var elements = document.querySelectorAll('[data-component="sermonDetail"]');

        elements.forEach(element => {
            var congregationId = element.getAttribute('data-congregationId');
            var sermonId = element.getAttribute("data-id");
            var sermonDetailsUrl = element.getAttribute('data-sermonUrl');
            var seriesDetailUrl = element.getAttribute('data-seriesUrl');
            var loadNotes = element.getAttribute('data-loadNotes');
            const lang = element.getAttribute('data-lang');

            var openNotes = false;

            if (loadNotes == 'True') {
                openNotes = true;
            }

            DEBUG && console.info('**************************************************');
            DEBUG && console.info('Init Sermon Detail');
            DEBUG && console.info(`Element:                 ${element.id}`);
            DEBUG && console.info(`Sermon Details:          ${sermonDetailsUrl}`);
            DEBUG && console.info(`Series Details:          ${seriesDetailUrl}`);
            DEBUG && console.info(`Open Notes:              ${openNotes}`);
            DEBUG && console.info(`Language:                ${lang}`);
            DEBUG && console.info('**************************************************');

            this.InitSermonDetail(element.id, sermonId, sermonDetailsUrl, seriesDetailUrl, openNotes, lang);
        });


        var latestElements = document.querySelectorAll('[data-component="sermonLatest"]');

        latestElements.forEach(element => {
            var congregationId = element.getAttribute('data-congregationId');
            var sermonDetailsUrl = element.getAttribute('data-sermonUrl');
            var seriesType = element.getAttribute('data-seriesType');
            var sermonDetailsUrl = element.getAttribute('data-sermonUrl');
            var seriesDetailUrl = element.getAttribute('data-seriesUrl');
            var requireMedia = element.getAttribute('data-requireMedia');
            const lang = element.getAttribute('data-lang');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info('Init Sermon Latest');
            DEBUG && console.info(`Element:                 ${element.id}`);
            DEBUG && console.info(`Congregation:            ${congregationId}`);
            DEBUG && console.info(`Series Type:             ${seriesType}`);
            DEBUG && console.info(`Sermon Details:          ${sermonDetailsUrl}`);
            DEBUG && console.info(`Series Details:          ${seriesDetailUrl}`);
            DEBUG && console.info(`Require Media:           ${requireMedia}`);
            DEBUG && console.info(`Language:                ${lang}`);
            var title = element.getAttribute('data-title');
            DEBUG && console.info('**************************************************');

            this.InitSermonLatestDetail(element.id, congregationId, seriesType, sermonDetailsUrl, seriesDetailUrl, requireMedia, sermonLatestTemplate, title, lang);
        });

        var latestCardElements = document.querySelectorAll('[data-component="sermonLatestCard"]');

        latestCardElements.forEach(element => {
            var congregationId = element.getAttribute('data-congregationId');
            var sermonDetailsUrl = element.getAttribute('data-sermonUrl');
            var seriesType = element.getAttribute('data-seriesType');
            var sermonDetailsUrl = element.getAttribute('data-sermonUrl');
            var seriesDetailUrl = element.getAttribute('data-seriesUrl');
            var requireMedia = element.getAttribute('data-requireMedia');
            var title = element.getAttribute('data-title');
            const lang = element.getAttribute('data-lang');

            var editMode = element.getAttribute('data-isEdit');
            var isEdit = false;
            if (editMode == 'True') {
                isEdit = true;
            }

            DEBUG && console.info('**************************************************');
            DEBUG && console.info('Init Sermon Latest Card');
            DEBUG && console.info(`Element:                 ${element.id}`);
            DEBUG && console.info(`Congregation:            ${congregationId}`);
            DEBUG && console.info(`Series Type:             ${seriesType}`);
            DEBUG && console.info(`Sermon Details:          ${sermonDetailsUrl}`);
            DEBUG && console.info(`Series Details:          ${seriesDetailUrl}`);
            DEBUG && console.info(`Require Media:           ${requireMedia}`);
            DEBUG && console.info(`Language:                ${lang}`);
            DEBUG && console.info('**************************************************');

            this.InitSermonLatestDetail(element.id, congregationId, seriesType, sermonDetailsUrl, seriesDetailUrl, requireMedia, sermonLatestCardTemplate, title, isEdit, lang);
        });

        var latestCardWideElements = document.querySelectorAll('[data-component="sermonLatestCardWide"]');

        latestCardWideElements.forEach(element => {
            var congregationId = element.getAttribute('data-congregationId');
            var sermonDetailsUrl = element.getAttribute('data-sermonUrl');
            var seriesType = element.getAttribute('data-seriesType');
            var sermonDetailsUrl = element.getAttribute('data-sermonUrl');
            var seriesDetailUrl = element.getAttribute('data-seriesUrl');
            var requireMedia = element.getAttribute('data-requireMedia');
            var title = element.getAttribute('data-title');
            const lang = element.getAttribute('data-lang');

            var editMode = element.getAttribute('data-isEdit');
            var isEdit = false;
            if (editMode == 'True') {
                isEdit = true;
            }

            DEBUG && console.info('**************************************************');
            DEBUG && console.info('Init Sermon Latest Card');
            DEBUG && console.info(`Element:                 ${element.id}`);
            DEBUG && console.info(`Congregation:            ${congregationId}`);
            DEBUG && console.info(`Series Type:             ${seriesType}`);
            DEBUG && console.info(`Sermon Details:          ${sermonDetailsUrl}`);
            DEBUG && console.info(`Series Details:          ${seriesDetailUrl}`);
            DEBUG && console.info(`Require Media:           ${requireMedia}`);
            DEBUG && console.info(`Language:                ${lang}`);
            DEBUG && console.info('**************************************************');

            this.InitSermonLatestDetail(element.id, congregationId, seriesType, sermonDetailsUrl, seriesDetailUrl, requireMedia, sermonLatestCardWideTemplate, title, isEdit);
        });
    }



    static SetupSeriesScroller() {
        DEBUG && console.info('Media Scroller *--> Init');
        var elements = document.querySelectorAll('[data-component="mediaScroller"]');

        elements.forEach(element => {
            var congregationId = element.getAttribute('data-congregationId');
            var seriesTypeId = element.getAttribute('data-seriesTypeId');
            var seriesDetailPageUrl = element.getAttribute('data-seriesDetailUrl');
            var sermonDetailPageUrl = element.getAttribute('data-sermonDetailUrl');
            var title = element.getAttribute('data-title');
            var mode = element.getAttribute('data-mode');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Congregation:            ${congregationId}`);
            DEBUG && console.info(`Series Type:             ${seriesTypeId}`);
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Series Detail Url:       ${seriesDetailPageUrl}`);
            DEBUG && console.info(`Sermon Detail Url:       ${sermonDetailPageUrl}`);
            DEBUG && console.info(`Mode:                    ${mode}`);
            DEBUG && console.info('**************************************************');

            this.InitSeriesScroller(element.id, congregationId, seriesTypeId, seriesDetailPageUrl, sermonDetailPageUrl, mode, title);
        });
    }

    static async InitSeriesScroller(elementId, congregationId, seriesTypeId, seriesDetailPageUrl, sermonDetailPageUrl, mode, title) {       
        const container = document.getElementById(elementId);

        if (mode === 'RecentSermons') {
            var data = await this.GetRecentSermons(congregationId, sermonDetailPageUrl, seriesDetailPageUrl, true, recentSermonsToLoad);
            var modelData = { "models": data };

            var content = await TemplateService.GetRenderedTemplate(recentSermonScrollerTemplate, modelData);

            container.innerHTML = content;
        }
        else {
            var data = await this.GetSeries(congregationId, seriesTypeId);
            var modelData = { "models": data, "detailPageUrl": seriesDetailPageUrl, "title": title };

            var content = await TemplateService.GetRenderedTemplate(seriesScrollerTemplate, modelData);

            container.innerHTML = content;
        }

    }

    static async GetSeries(congregationId, seriesTypeId) {
        var data = await api.getData(`Sermon/GetCampusSeries?congregationId=${congregationId}&seriesTypeId=${seriesTypeId}`);
        DEBUG && console.info(data);
        return data;
    }

    static async GetRecentSermons(congregationId, sermonDetailsUrl, seriesDetailUrl, requireMedia, count) {
        var data = await api.getData(`Sermon/GetRecentSermons/?congregationId=${congregationId}&sermonDetailsUrl=${sermonDetailsUrl}&seriesDetailUrl=${seriesDetailUrl}&requireMedia=${requireMedia}&Count=${count}`);

        DEBUG && console.info(data);
        return data;
    }


    static async InitSeriesDetail(elementId, seriesId, sermonDetailsUrl) {
        const container = document.getElementById(elementId);
        var data = await this.GetSeriesDetails(seriesId, sermonDetailsUrl);

        var content = await TemplateService.GetRenderedTemplate(seriesDetailTemplate, data);

        container.innerHTML = content;
    }

    static async GetSeriesDetails(seriesId, sermonDetailsUrl) {
        var data = await api.getData(`Sermon/GetSeries/${seriesId}?sermonDetailsUrl=${sermonDetailsUrl}`);
        DEBUG && console.info(data);
        return data;
    }



    static async InitSermonDetail(elementId, sermonId, sermonDetailsUrl, seriesDetailUrl, openNotes, defaultLanguage) {
        let self = this;

        var localTemplate = sermonDetailTemplate;

        if (openNotes) {
            localTemplate = sermonNotesTemplate;
        }

        const container = document.getElementById(elementId);
        var data = await this.GetSermonDetails(sermonId, sermonDetailsUrl, seriesDetailUrl);

        // Check for start QueryString Parameter
        // Get the current URL's query string parameters
        const params = new URLSearchParams(window.location.search);

        let startValue = null;
        // Check if the 'start' parameter exists
        if (params.has('start')) {
            // Get the value of the 'start' parameter
            startValue = params.get('start');  
            console.log('|||===> START Detected');
        }

        // Add API Root to Data
        data.apiRoot = apiRoot;

        // Add Language Data
        const currentLanguage = LangService.getCurrentLanguage(defaultLanguage);

        data.langData = await LangService.load(componentName, currentLanguage);

        // Assemble and update the data for bookmarks
        try {
            data.BookmarkData = data.Bookmarks && JSON.parse(data.Bookmarks);

            if (Array.isArray(data.BookmarkData)) {
                data.BookmarkData.forEach(bookmark => {
                    if (bookmark.TimeCode) {

                        var working = bookmark.TimeCode;

                        if (working.includes(',')) {
                            working = working.split(',')[0];
                        }

                        const [hours, minutes, seconds] = working.split(':').map(Number);
                        bookmark.TimeCodeSeconds = hours * 3600 + minutes * 60 + seconds;
                    }
                });
            }
        } catch (e) {
            console.error("Invalid JSON in Bookmarks");
        }
        

        console.log('Rendering Sermon Details:');
        console.log(data);
        var content = await TemplateService.GetRenderedTemplate(localTemplate, data);

        container.innerHTML = content;


        // Initialize the Player
        // Get Player Element
        const currentSermonPlayerEl = container.querySelectorAll(`div[data-component="sermonPlayer"]`)[0];


        if (data.Video && data.Video.Link_URL && !openNotes) {

            self.playVideo(data, currentSermonPlayerEl, false, startValue);

            const btnVideo = document.getElementById('btnVideo');
            btnVideo.style.display = "inline";

            btnVideo.addEventListener('click', function () {
                self.playVideo(data, currentSermonPlayerEl, true, null);
            });
        }

        if (data.Audio && data.Audio.Link_URL && !openNotes) {

            if (!data.Video || !data.Video.Link_URL) {
                self.playAudio(data, currentSermonPlayerEl, false, startValue);
            }
            
            const btnAudio = document.getElementById('btnAudio');
            btnAudio.style.display = "inline";

            btnAudio.addEventListener('click', function () {
                self.playAudio(data, currentSermonPlayerEl, true, null);
            });
        }

        if (!openNotes) {
            // Get current Sermon li element
            const currentSermonEl = document.querySelectorAll(`li[data-id="${sermonId}"]`)[0];
            DEBUG && console.info(currentSermonEl);

            // Highlight Current Sermon
            const currentSermonImageEl = document.querySelectorAll(`li[data-id="${sermonId}"] > a > figure > picture > img`)[0];
            DEBUG && console.info(currentSermonImageEl);
            currentSermonImageEl.classList.add('highlighted');

            // Hide if only 1 Sermon
            if (data.Series.Sermons.count < 2) {
                const seriesScroller = document.getElementById("SermonSeriesScroller");
                seriesScroller.style.display = "none";
            }

            // Create small Timeout before Scrolling to Current Sermon
            setTimeout(() => {
                // Scroll to Center the current Sermon
                this.CenterSermon(currentSermonEl);
            }, 350);
        }


        // Setup Bookmarks to Jump
        const bookMarkElements = container.querySelectorAll(`.bookmark-item`);
        bookMarkElements.forEach(item => {
            item.addEventListener('click', () => {
                const jumpTo = parseInt(item.dataset.jump, 10);
                if (!isNaN(jumpTo) && typeof currentSermonPlayerEl !== 'undefined') {
                    jwplayer(currentSermonPlayerEl.id).seek(jumpTo);
                    jwplayer(currentSermonPlayerEl.id).play(true);
                }
            });
        });

        await this.SetupSermonNotes(sermonId, 'sermonNotes', 'containerSermonNotes', 'btnSermonNotes');

        // Conditionally setup Transcriptions
        if (data.Transcriptions) {
            await this.SetupTranscription(data, 'sermonTranscript', 'containerSermonTranscript', 'btnSermonTranscript', currentLanguage);
        }
        
    }

    static CenterSermon(currentSermonEl) {
        DEBUG && console.info('Centering Current Sermon');
        currentSermonEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    static async GetSermonDetails(sermonId, sermonDetailsUrl, seriesDetailUrl) {
        var data = await api.getData(`Sermon/GetSermon/${sermonId}?sermonDetailsUrl=${sermonDetailsUrl}&seriesDetailUrl=${seriesDetailUrl}`);
        DEBUG && console.info(data);
        return data;
    }

    static async InitSermonLatestDetail(elementId, congregationId, seriesType, sermonDetailsUrl, seriesDetailUrl, requireMedia, template, title, isEdit, defaultLanguage) {
        const container = document.getElementById(elementId);
        var data = await this.GetLastestSermon(congregationId, seriesType, sermonDetailsUrl, seriesDetailUrl, requireMedia);

        var template = template;

        // Add Title to the Data Object
        var sermonObj = {};
        sermonObj.title = title;
        sermonObj.sermon = data;
        sermonObj.isEdit = isEdit;
        sermonObj.langData = await LangService.load(componentName, defaultLanguage);

        var content = await TemplateService.GetRenderedTemplate(template, sermonObj);

        container.innerHTML = content;

        if (!isEdit) {
            container.onclick = () => {
                window.location.href = data.SermonUrl;
            };
        }
    }

    static async GetLastestSermon(congregationId, seriesType, sermonDetailsUrl, seriesDetailUrl, requireMedia) {
        var data = await api.getData(`Sermon/GetLatestSermon/?congregationId=${congregationId}&serviceTypeId=${seriesType}&sermonDetailsUrl=${sermonDetailsUrl}&seriesDetailUrl=${seriesDetailUrl}&requireMedia=${requireMedia}`);

        DEBUG && console.info(data);
        return data;
    }

    static async SetupSermonNotes(sermonId, sermonNotesElement, sermonNotesContainerElement, sermonNotesButtonElement) {
        const elementButton = document.getElementById(sermonNotesButtonElement);
        const elementNotesContainer = document.getElementById(sermonNotesContainerElement);
        const elementNotes = document.getElementById(sermonNotesElement);
        const elementPrintNotes = document.getElementById('sermonPrintNotes');
        const btnPrintNotes = document.getElementById('btnPrintNotes');

        const containerPrintSermonNotes = document.getElementById('containerPrintSermonNotes');
        const containerPrintSermonTranscription = document.getElementById('containerPrintSermonTranscription');

        var data = await api.getData(`Sermon/GetSermonNotes/${sermonId}`);

        if (data) {
            elementNotes.innerHTML = data.Sermon_Notes;
            elementPrintNotes.innerHTML = data.Sermon_Notes;
            if (elementButton) {
                elementButton.addEventListener('click', (evt) => {                        
                    if (elementNotesContainer.style.display == 'none') {                        
                        this.hideAll();
                        elementNotesContainer.style.display = 'inline-block';
                        elementButton.classList.add('btn-outline-primary');
                        elementButton.classList.remove('btn-outline-secondary');
                    }
                    else {
                        this.hideAll();
                    }
                });

                elementButton.style.display = 'inline-block';
            }

            // Wire up Print Button
            btnPrintNotes.addEventListener('click', function () {

                // Class name to toggle
                const printClass = 'd-print-block';                

                // If transcription has the class, remove it
                if (containerPrintSermonTranscription.classList.contains(printClass)) {
                    containerPrintSermonTranscription.classList.remove(printClass);
                }

                // If notes doesn't have the class, add it
                if (!containerPrintSermonNotes.classList.contains(printClass)) {
                    containerPrintSermonNotes.classList.add(printClass);
                }

                window.print();
                return false;
            });
        }
    }

    static async SetupTranscription(sermonData, tranNotesElement, tranNotesContainerElement, tranNotesButtonElement, defaultLanguage) {
        const elementButton = document.getElementById(tranNotesButtonElement);
        const elementTranscriptionContainer = document.getElementById(tranNotesContainerElement);
        const elementTranscription = document.getElementById(tranNotesElement);
        const elementPrintTranscript = document.getElementById('sermonPrintTranscription');
        const btnPrintTranscript = document.getElementById('btnPrintTranscript');
        const btnDownloadTranscript = document.getElementById('btnDownloadTranscript');

        const containerPrintSermonNotes = document.getElementById('containerPrintSermonNotes');
        const containerPrintSermonTranscription = document.getElementById('containerPrintSermonTranscription');

        console.log('====> Setup Transcription');
        console.log('Default Language: ', defaultLanguage);
        console.log(sermonData);

        const transcription = sermonData.Transcriptions.find(obj => obj.Language === defaultLanguage)
            || sermonData.Transcriptions[0];


        var data = await api.getData(`Sermon/GetSermonTranscript?id=${transcription.Pocket_Platform_Sermon_Transcription_ID}`);

        console.log(data);

        if (data) {
            const fileName = `${sermonData.Sermon_Number}-${data.Language}.pdf`;
            console.log(`FileName: ${fileName}`);

            btnDownloadTranscript.href = `${apiRoot}/api/Sermon/DownloadTranscript?transcriptId=${transcription.Pocket_Platform_Sermon_Transcription_ID}&fileName=${fileName}`;

            elementTranscription.innerHTML = data.Transcription;
            elementPrintTranscript.innerHTML = data.Transcription;
            if (elementButton) {
                elementButton.addEventListener('click', (evt) => {                    
                    if (elementTranscriptionContainer.style.display == 'none') {
                        this.hideAll();
                        elementTranscriptionContainer.style.display = 'inline-block';
                        elementButton.classList.add('btn-outline-primary');
                        elementButton.classList.remove('btn-outline-secondary');
                    }
                    else {
                        this.hideAll();
                    }
                });

                elementButton.style.display = 'inline-block';
            }

            // Wire up Print Button
            btnPrintTranscript.addEventListener('click', function () {

                // Class name to toggle
                const printClass = 'd-print-block';

                // If transcription has the class, remove it
                if (!containerPrintSermonTranscription.classList.contains(printClass)) {
                    containerPrintSermonTranscription.classList.add(printClass);
                }

                // If notes doesn't have the class, add it
                if (containerPrintSermonNotes.classList.contains(printClass)) {
                    containerPrintSermonNotes.classList.remove(printClass);
                }

                window.print();
                return false;
            });
        }
    }

    static hideAll() {
        let notesElement = document.getElementById('containerSermonNotes');
        let transElement = document.getElementById('containerSermonTranscript');

        notesElement.style.display = 'none';
        transElement.style.display = 'none';

        const notesButton = document.getElementById('btnSermonNotes');
        const transcriptButton = document.getElementById('btnSermonTranscript');

        if (notesButton.classList.contains('btn-outline-primary')) {
            notesButton.classList.remove('btn-outline-primary');
            notesButton.classList.add('btn-outline-secondary');
        }

        if (transcriptButton.classList.contains('btn-outline-primary')) {
            transcriptButton.classList.remove('btn-outline-primary');
            transcriptButton.classList.add('btn-outline-secondary');
        }
    }

    static createTrackList(trackData) {
        if (trackData) {
            return trackData.map(track => ({
                kind: 'captions',
                file: `${apiRoot}/api/Sermon/GetSermonSRT?id=${track.Pocket_Platform_Sermon_Transcription_ID}`,
                label: track.LanguageDisplayName
            }));

        }
        return null;
    }

    static saveVideoPosition(data, currentTime, currentIndex) {
        const key = `sermonProgress_${data.Sermon_ID}`;
        let replay = false;
        if (data.Worship) {
            replay = true;
        }
        const value = { time: currentTime, index: currentIndex, replay: replay, updated: new Date().toISOString() };
        localStorage.setItem(key, JSON.stringify(value));
    }


    static playVideo(data, currentSermonPlayerEl, switchToVideo, startValue) {
        console.log("===> playVideo function called <===");
        console.log('Data:', data);
        console.log('SwitchToVideo: ', switchToVideo);
        console.log('StartValue: ', startValue);

        let self = this;
        self.playlistIndex = 0;
        let sermonSeconds = 0;        
        let loadedSavePoint = false;
        let timeListenerAdded = false;

        if (startValue !== undefined && startValue) {
            sermonSeconds = Number(startValue);
            console.log('***> Start Value Seconds:', sermonSeconds);

            self.playlistIndex = 1;

            if (data.Worship) {
                self.playlistIndex = 2;
            }

            console.log('***> Setting Player Index:', self.playlistIndex);
        }
        else {
            const savedProgress = JSON.parse(localStorage.getItem(`sermonProgress_${data.Sermon_ID}`));
            console.log(savedProgress);

            if (savedProgress) {

                let isReplayActive = !!data.Worship;

                if (isReplayActive && savedProgress.replay) {
                    self.playlistIndex = savedProgress.index;
                    sermonSeconds = savedProgress.time;
                }
                else if (!isReplayActive && !savedProgress.replay) {
                    self.playlistIndex = savedProgress.index;
                    sermonSeconds = savedProgress.time;
                }
                else if (!isReplayActive && savedProgress.replay) {
                    if (savedProgress.index == 2) {
                        self.playlistIndex = 1;
                        sermonSeconds = savedProgress.time;
                    }
                }
            }
        }

        // Create an empty array for your playlist
        var videoplaylist = [];

        // Push the first element (e.g., the intro)
        videoplaylist.push({
            title: `${data.Title}`,
            image: `${data.Series.Series.Image_URL}`,
            file: 'https://ep-default-calvaryccm.eastus.streaming.mediakind.com/fff1426c-b562-4a72-a6b8-6e12c33c0cd6/IntroVideo.ism/manifest(format=m3u8-cmaf)'
        });

        // Worship URL if exists
        if (data.Worship) {
            videoplaylist.push({
                title: `${data.Title}`,
                image: `${data.Series.Series.Image_URL}`,
                file: `${data.Worship.Link_URL}`
            });
        }

        // Push the main sermon content
        videoplaylist.push({
            title: `${data.Title}`,
            image: `${data.Series.Series.Image_URL}`,
            file: `${data.Video.Link_URL}`,
            tracks: this.createTrackList(data.Transcriptions)
        });


        // Push the third element (e.g., the outro)
        videoplaylist.push({
            title: `${data.Title}`,
            image: `${data.Series.Series.Image_URL}`,
            file: 'https://ep-default-calvaryccm.eastus.streaming.mediakind.com/712c98c5-2506-477e-beea-c59bb39c3d58/Outro.ism/manifest(format=m3u8-cmaf)'
        });


        if (switchToVideo) {
            jwplayer(currentSermonPlayerEl.id).remove();
        }

        let saveInterval = null;
        let lastSaved = 0;

            console.info('Setup and Play Sermon');
            let playerInstance = jwplayer(currentSermonPlayerEl).setup({
                height: 'auto',
                width: '100%',
                nextUpDisplay: false,
                playlist: videoplaylist,
                autostart: true,
                preload: "auto",
                playlistIndex: self.playlistIndex
            });

            playerInstance.on('ready', function () {
                console.log('JWPlayer Ready Fired...');
            });

            playerInstance.on('play', function () {
                console.log('JWPlayer Play Fired...');
                clearInterval(saveInterval);
                saveInterval = setInterval(() => {
                    const currentTime = playerInstance.getPosition();
                    // Only save if at least 10 seconds have passed since last save
                    if (Math.floor(currentTime) - lastSaved >= 5) {
                        lastSaved = Math.floor(currentTime);
                        console.log('Current Time Index:', lastSaved);
                        console.log('Current Playlist Index:', self.playlistIndex);
                        console.log('Sermon_ID:', data.Sermon_ID);
                        self.saveVideoPosition(data, lastSaved, self.playlistIndex);
                    }
                }, 10000);
            });

        playerInstance.on('pause', () => {
            clearInterval(saveInterval);
        });

        playerInstance.on('complete', () => {
            clearInterval(saveInterval);
        });

            playerInstance.on('playlistItem', function (event) {
                console.info('On PlayListItem Fired');
                console.log(sermonSeconds);
                console.log(loadedSavePoint);

                self.playlistIndex = event.index;
                console.log('|||===> Playing Index: ', self.playlistIndex);

                if (sermonSeconds > 0 && !loadedSavePoint && !timeListenerAdded == true) {
                    timeListenerAdded = true;
                    console.log('|||===> Setup to load saved spot');                    
                    playerInstance.on('time', function (event) {
                        console.info('On Time Fired');
                        if (event.position >= 0 && sermonSeconds > 0) {
                            console.info('Advancing Sermon');
                            console.info('Turning off Time');
                            playerInstance.off('time');
                            playerInstance.seek(sermonSeconds);                                                        
                            loadedSavePoint = true;
                        }                        
                    });
                }
                else {
                    console.log('|||===> Normal Sermon Load');
                }
            });
        
    }



    static playAudio(data, currentSermonPlayerEl, switchToAudio) {
        var audioplaylist = [{
            'title': `${data.Title}`,
            'image': `${data.Series.Series.Image_URL}`,
            'file': `${data.Audio.Link_URL}`
        }];

        if (switchToAudio) {
            jwplayer(currentSermonPlayerEl.id).remove();
        }

        jwplayer(currentSermonPlayerEl).setup({
            height: 'auto',
            width: '100%',
            nextUpDisplay: false,
            preload: "auto",
            playlist: audioplaylist
        });
    }
}


